module.exports = __webpack_public_path__ + "static/media/Poppins-Italic.07502c4f.ttf";